import React from "react";
import PropTypes from "prop-types";

import { Redirect, Route } from "react-router-dom";

import { GET_STORAGE } from "../../core/utils";
import { LOGIN } from "../../core/routes/constants";

export default function PrivateRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => {
                const isLoggedIn = GET_STORAGE("is_loggedIn");

                if (isLoggedIn && props.location.search) {
                    return (
                        <Redirect
                            to={{
                                pathname: props.location.pathname,
                                search: "",
                            }}
                        />
                    );
                } else if (isLoggedIn && !props.location.search) {
                    return <Component {...props} />;
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: LOGIN,
                                state: { from: props.location.pathname },
                                search: props.location.search,
                            }}
                        />
                    );
                }
            }}
        />
    );
}

PrivateRoute.propTypes = {
    component: PropTypes.any,
    location: PropTypes.object,
};
